"use client"

import { useState, useEffect } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { Button } from '../components/ui/button';

const slides = [
  {
    id: 1,
    image: "/content/Images/prof1.png",
    title: "Professional Mortgage Solutions",
    subtitle: "Empowering Your Success in Non-QM Lending",
  },
  {
    id: 2,
    image: "/content/Images/prof2.png",
    title: "Expert Loan Origination Team",
    subtitle: "Independent But Not Alone",
  },
  {
    id: 3,
    image: "/content/Images/prof3.png",
    title: "Dedicated Support & Service",
    subtitle: "Your Partner in Mortgage Excellence",
  },
  {
    id: 4,
    image: "/content/Images/prof2.png",
    title: "Innovative Lending Solutions",
    subtitle: "Bridging the Gap for Creditworthy Borrowers",
  },
]

export default function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length)
    }, 5000)

    return () => clearInterval(timer)
  }, [])

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
  }

  return (
    <div className="relative h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? "opacity-100" : "opacity-0"}`}
        >
          {/* Replaced next/image with img */}
          <img
            src={slide.image || "/placeholder.svg"}
            alt={slide.title}
            className="object-cover w-full h-full absolute inset-0"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/60 via-blue-900/30 to-transparent" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white space-y-6 px-4 max-w-4xl">
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight">{slide.title}</h2>
              <p className="text-xl md:text-2xl lg:text-3xl font-light opacity-90">{slide.subtitle}</p>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      <Button
        variant="ghost"
        size="icon"
        className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:bg-white/20"
        onClick={prevSlide}
      >
        <ChevronLeft className="h-6 w-6" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:bg-white/20"
        onClick={nextSlide}
      >
        <ChevronRight className="h-6 w-6" />
      </Button>

      {/* Dots Indicator */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full transition-colors ${index === currentSlide ? "bg-white" : "bg-white/50"}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  )
}
